module.exports = "/packs/icon-place-9d1f87a070474361ed6d0c3870e655f6.png";